import { useEffect, useState, useRef } from 'react';
import { getSystemStatus } from '../api/services/infrastructure';

const POLL_INTERVAL = 5000; // 5 seconds

export default function useInfrastructureStatus() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const mountedRef = useRef(true);

  useEffect(() => {
    mountedRef.current = true;

    const fetchStatus = async (isInitial = false) => {
      try {
        const res = await getSystemStatus();
        if (mountedRef.current) {
          setData(res);
          if (isInitial) setLoading(false);
        }
      } catch (err) {
        if (mountedRef.current) {
          setError(err);
          if (isInitial) setLoading(false);
        }
      }
    };

    fetchStatus(true);

    const intervalId = setInterval(() => fetchStatus(false), POLL_INTERVAL);

    return () => {
      mountedRef.current = false;
      clearInterval(intervalId);
    };
  }, []);

  return { data, loading, error };
}
